module.exports = __webpack_public_path__ + "img/Salvia_miltiorrhiza.538ecee4.jpg";